import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from '../../translations'

class NotFound extends Component {
  render() {
    return <h1>{this.props.t('common.notFound')}</h1>
  }
}

NotFound.propTypes = {
  t: PropTypes.func.isRequired,
}

export default withTranslation(NotFound)
